import { Tab } from "api/call-center/routes/models";
import { queryString } from "utilities";

type GetSearchProps = {
  tab: Tab;
  query: {
    [x: string]: string;
  };
};

export const getSearch = ({ query, tab }: GetSearchProps): string => {
  const tabUpper = tab.toUpperCase();
  const tabsQuery = {
    status: tabUpper !== "ALL" ? tabUpper.replace("-", "_") : "",
  };
  return queryString.stringify({
    ...query,
    ...tabsQuery,
  });
};
